<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            员工列表
        </div>
        <div style="padding: 20px;">

            <div>

                <el-row style="float: left;">
                    <el-dropdown trigger="click" style="margin-right:10px" @command='addOpen'>
                        <el-button type="primary">
                            添加员工<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item :command="toggleModalDeanAdd">院长</el-dropdown-item>
                            <el-dropdown-item :command="toggleModalFinanceAdd">财务</el-dropdown-item>
                            <el-dropdown-item :command="toggleModalNurseAideAdd">护工</el-dropdown-item>
                            <el-dropdown-item :command="toggleModalSecurityGuardAdd">保安</el-dropdown-item>
                            <el-dropdown-item :command="toggleModalOtherAdd">其他</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <!-- <el-button type="primary" :disabled="disabledAddDean" @click.native="toggleModalDeanAdd">院长添加</el-button>
                    <el-button type="primary" :disabled="disabledAddFinance" @click.native="toggleModalFinanceAdd">财务添加</el-button>
                    <el-button type="primary" :disabled="disabledAddHuGong" @click.native="toggleModalNurseAideAdd">护工添加</el-button>
                    <el-button type="primary" :disabled="disabledAddBaoAn" @click.native="toggleModalSecurityGuardAdd">保安添加</el-button> -->
                    <el-button type="success" :disabled="disabledEdit" @click="handleEdit">编辑</el-button>
                    <el-button type="danger" :disabled="disabledDaKa" @click="handleClockin">打卡记录下载</el-button>
                </el-row>
                <div style="float:right">
                    <el-input  placeholder="请输入用户姓名" v-model="name" clearable style="margin:0 5px;width:200px"></el-input>
                    <el-select
                        v-model="departmentCode"
                        style="margin:0 5px;width:200px"
                        clearable
                        placeholder="请选择用户所属部门">
                        <el-option
                            v-for="item in departmentList"
                            :key="item.departmentCode"
                            :label="item.name"
                            :value="item.departmentCode">
                        </el-option>
                    </el-select>
                    <el-select
                        v-model="status"
                        style="margin:0 5px;width:200px"
                        placeholder="请选择用户状态">
                        <el-option
                            v-for="(item,i) in statusValue"
                            :key="i"
                            :label="item"
                            :value="i">
                        </el-option>
                    </el-select>
                    <el-select
                        v-model="userType"
                        style="margin:0 5px;width:200px"
                        placeholder="请选择用户用户类型">
                        <el-option
                            v-for="item in userTypeValue"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    <el-button style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                </div>
                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>
                    <el-table :data="tableData" v-loading="loading" highlight-current-row @row-click="rowClick" :height="th" border style="width: 100%;">

                        <el-table-column prop="name" label="姓名"></el-table-column>

                        <el-table-column prop="phone" label="手机号"></el-table-column>

                        <!-- <el-table-column label="头像">
                            <template slot-scope="scope">
                                 <el-popover placement="right" trigger="click" v-if="scope.row.headImg">
                                    <img :src="imgUrl+scope.row.headImg"  style="width: 500px"/>
                                    <img slot="reference" :src="imgUrl+scope.row.headImg" style="width:100%">
                                </el-popover>
                            </template>
                        </el-table-column> -->
                        <el-table-column prop="departmentName" label="部门"></el-table-column>
                        <el-table-column prop="userType" :formatter="getUserType" label="用户类型"></el-table-column>
                        <el-table-column
                                prop="Status"
                                :formatter="statusTitle"
                                label="状态">
                        </el-table-column>
                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>
        <el-dialog
            title="打卡记录范围"
            :visible.sync="showModalClockin"
            top='30vh'
            width="500px" :close-on-click-modal='false'>
            <el-row :gutter='20'>
                <el-form>
                    <el-col :span="12">
                        <el-form-item label="开始日期" required>
                            <el-date-picker
                                v-model="startTime"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="开始日期"
                                :clearable='false'
                                :picker-options='startOptions'
                                @change="getStartOptions"
                                style="width:200px;"
                                >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="结束日期" required>
                            <el-date-picker
                                v-model="endTime"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="结束日期"
                                :clearable='false'
                                :picker-options='endOptions'
                                @change="getEndOptions"
                                style="width:200px;"
                                >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
            </el-form>
            </el-row>
            
            <div slot="footer" class="dialog-footer">
                <el-button @click="showModalClockin = false">取 消</el-button>
                <el-button type="primary" :loading="loadingClockin" @click="confirmClockin">确 定</el-button>
            </div>
        </el-dialog>
        <NurseAideAdd ref="myNurseAideAdd" v-show="showModalNurseAideAdd" v-bind:departmentList="departmentList" v-on:close="closeNurseAideAdd" v-on:getList="getList"></NurseAideAdd>
        <NurseAideEdit ref="myNurseAideEdit" v-show="showModalNurseAideEdit" v-bind:departmentList="departmentList" v-on:close="closeNurseAideEdit" v-on:getList="getList"></NurseAideEdit>
        <SecurityGuardAdd ref="mySecurityGuardAdd" v-show="showModalSecurityGuardAdd" v-bind:departmentList="departmentList" v-on:close="showModalSecurityGuardAdd=false" v-on:getList="getList"></SecurityGuardAdd>
        <SecurityGuardEdit ref="mySecurityGuardEdit" v-show="showModalSecurityGuardEdit" v-bind:departmentList="departmentList" v-on:close="showModalSecurityGuardEdit=false" v-on:getList="getList"></SecurityGuardEdit>
        <DeanAdd ref="myDeanAdd" v-show="showModalDeanAdd" v-bind:departmentList="departmentList" v-bind:areaValue="areaValue" v-on:close="closeDeanAdd" v-on:getList="getList"></DeanAdd>
        <DeanEdit ref="myDeanEdit" v-show="showModalDeanEdit" v-bind:departmentList="departmentList" v-bind:areaValue="areaValue" v-on:close="closeDeanEdit" v-on:getList="getList"></DeanEdit>
        <FinanceAdd ref="myFinanceAdd" v-show="showModalFinanceAdd" v-bind:departmentList="departmentList" v-bind:areaValue="areaValue" v-on:close="closeFinanceAdd" v-on:getList="getList"></FinanceAdd>
        <FinanceEdit ref="myFinanceEdit" v-show="showModalFinanceEdit" v-bind:departmentList="departmentList" v-bind:areaValue="areaValue" v-on:close="closeFinanceEdit" v-on:getList="getList"></FinanceEdit>
        <OtherAdd ref="myOtherAdd" v-show="showModalOtherAdd" v-bind:departmentList="departmentList" v-bind:areaValue="areaValue" v-on:close="showModalOtherAdd=false" v-on:getList="getList"></OtherAdd>
        <OtherEdit ref="myOtherEdit" v-show="showModalOtherEdit" v-bind:departmentList="departmentList" v-bind:areaValue="areaValue" v-on:close="showModalOtherEdit=false" v-on:getList="getList"></OtherEdit>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import NurseAideAdd from "./NurseAideAdd";
    import NurseAideEdit from "./NurseAideEdit";
    import SecurityGuardAdd from "./SecurityGuardAdd";
    import SecurityGuardEdit from "./SecurityGuardEdit";
    import DeanAdd from "./DeanAdd";
    import DeanEdit from "./DeanEdit";
    import FinanceAdd from "./FinanceAdd";
    import FinanceEdit from "./FinanceEdit";
    import OtherAdd from "./OtherAdd";
    import OtherEdit from "./OtherEdit";
    import {getStaffCode,getMenuButton} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:true,
                showModalClockin:false,
                dataInfo:false,
                showModalAdd:false,
                showModalEdit:false,
                showModalNurseEdit:false,
                disabledAddDean:true,
                disabledAddFinance:true,
                disabledAddHuGong:true,
                disabledAddBaoAn:true,
                disabledEdit:true,
                disabledDaKa:true,
                showModalSecurityGuardAdd:false,
                showModalSecurityGuardEdit:false,
                showModalElderlyAdd:false,
                showModalElderlyEdit:false,
                showModalNurseAdd:false,
                showModalNurseAideAdd:false,
                showModalNurseAideEdit:false,
                showModalDeanAdd:false,
                showModalDeanEdit:false,
                showModalOtherAdd:false,
                showModalOtherEdit:false,
                showModalFinanceAdd:false,
                showModalFinanceEdit:false,
                showModalMedicinerAdd:false,
                showModalMedicinerEdit:false,
                loadingClockin:false,
                tableData:null,
                departmentList:[],
                areaValue:[],
                totalItems: 0,
                row:null,
                pageSize:20,
                currentPage:1,
                th:0,
                phone:'',
                name:'',
                status:0,
                userType:-1,
                departmentCode:'',
                tabindexAdd:'',
                userTypeValue:[{
                    "value":-1,
                    "label":"全部用户"
                },{
                     "value":5,
                    "label":"护工"
                },{
                     "value":6,
                    "label":"员工"
                },{
                     "value":7,
                    "label":"保安"
                },{
                     "value":8,
                    "label":"院长"
                },{
                     "value":9,
                    "label":"财务"
                },{
                     "value":10,
                    "label":"其他"
                }],
                statusValue:['用户状态','正常','禁用'],
                startTime:'',
                endTime:'',
                startOptions:{
                    disabledDate(time) {
                        return time.getTime() > Date.now()
                    },
                },
                endOptions:{
                    disabledDate(time) {
                        return time.getTime() > Date.now()
                    },
                },
            }
        },
        components:{
            NurseAideAdd,NurseAideEdit,DeanAdd,DeanEdit,
            SecurityGuardEdit,SecurityGuardAdd,FinanceAdd,FinanceEdit,
            OtherEdit,OtherAdd
        },
        created(){
            this.init();
            this.getList();
            this.getMenu();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{
            getMenu(){
                let list = JSON.parse(window.localStorage.getItem("listMenuDTO"));
                var menu = getMenuButton(list,this.$route.path);
                this.menuButtonList = JSON.stringify(menu);
                if(menu!=null&&menu.length>0){
                    for(let i=0;i<menu.length;i++){
                        if(menu[i].buttonName=="添加员工"){
                            this.disabledAddHuGong = false;
                        }
                        // if(menu[i].buttonName=="保安添加"){
                        //     this.disabledAddBaoAn = false;
                        // }
                        // if(menu[i].buttonName=="院长添加"){
                        //     this.disabledAddDean = false;
                        // }
                        // if(menu[i].buttonName=="财务添加"){
                        //     this.disabledAddFinance = false;
                        // }
                    }
                }
            },
            formatterTime1(row, column, cellValue) {
                return cellValue?cellValue.replace('T',' ').slice(0,10):null
            },
            rowClick(row){
                this.row=row;
                if(this.menuButtonList.indexOf("编辑")!=-1){
                    if(row.userType==5||row.userType==7||row.userType==8||row.userType==9||row.userType==10){
                         this.disabledEdit =false;
                    }else{
                        this.disabledEdit = true;
                    }
                }
                if(this.menuButtonList.indexOf("打卡记录下载")!=-1){
                    this.disabledDaKa =false;
                }
                
            },
            addOpen(value){
                value()
            },
            init(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Department/List",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode:getStaffCode(),
                    }
                }).then(
                    (response) => {
                        if (response.data.error == 0) {
                            this.departmentList=response.data.data
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Area/ListAll",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then(
                    (response) => {
                        if (response.data.error == 0) {
                            var data=JSON.stringify(response.data.data);
                            data=JSON.parse(data.replace(/"listAreaDTO":\[\],/g,''))
                            this.areaValue = data
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },
            getStartOptions(e){
                this.endOptions={
                    disabledDate(time) {
                        return time.getTime() > Date.now() || time.getTime() < new Date(e).getTime()
                    },
                }
            },
            getEndOptions(e){
                this.startOptions={
                    disabledDate(time) {
                        return time.getTime() > Date.now() || time.getTime() > new Date(e).getTime()
                    },
                }
            },
            handleClockin(){
                this.showModalClockin=true
                this.dataInfo=this.row
                this.startTime=''
                this.endTime=''
            },
            confirmClockin(){
                if(!this.startTime){
                    this.$message.error('请选择开始时间')
                    return;
                }
                if(!this.endTime){
                    this.$message.error('请选择结束时间')
                    return;
                }
                this.loadingClockin=true
                this.$axios.get(this.$institutionUrl+'ClockinRecordExport/ExportClockRecord',{
                    responseType: 'blob',
                    params:{
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode:getStaffCode(),
                        userCode:this.dataInfo.userCode,
                        startTime:this.startTime,
                        endTime:this.endTime
                    }
                }).then(
                    (response) => {
                        this.loadingClockin=false
                        if(response.data.type=='application/json'){
                            this.$message({type: 'info', message: '暂无数据'});
                            this.showModalClockin=false
                        }else{
                            let fileName = '打卡记录.xlsx';
                            this.file(response,fileName);
                            this.showModalClockin=false
                        }
                        
                    }
                )
            },
            file(response,fileName){
                let blob = new Blob([response.data]);
                if (window.navigator.msSaveOrOpenBlob) {
                    navigator.msSaveBlob(blob,fileName);
                } else {
                    let elink = document.createElement("a");
                    elink.download = fileName;
                    elink.style.display = "none";
                    elink.href = URL.createObjectURL(blob)
                    document.body.appendChild(elink);
                    elink.click();
                    URL.revokeObjectURL(elink.href);
                    document.body.removeChild(elink);
                }
            },
            handleEdit() {
                switch(this.row.userType){
                    // case 1:
                    //     this.closeElderlyEdit();
                    //     this.$refs.myElderlyEdit.init(row);
                    //     break;
                    
                    case 5:
                        this.closeNurseAideEdit();
                        this.$refs.myNurseAideEdit.init(this.row);
                        break;
                    
                    case 7:
                        this.showModalSecurityGuardEdit=true;
                        this.$refs.mySecurityGuardEdit.init(this.row);
                        break;
                    case 8:
                        this.closeDeanEdit();
                        this.$refs.myDeanEdit.init(this.row);
                        break;
                    case 9:
                        this.closeFinanceEdit();
                        this.$refs.myFinanceEdit.init(this.row);
                        break;
                    case 10:
                        this.showModalOtherEdit=true
                        this.$refs.myOtherEdit.init(this.row);
                        break;
                }
            },
            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            toggleModalEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            toggleModalNurseAdd(){
                this.closeNurseAdd();
                this.$refs.myNurseAdd.init();
            },
            toggleModalOtherAdd(){
                this.showModalOtherAdd=true
                this.$refs.myOtherAdd.init();
            },
            toggleModalSecurityGuardAdd(){
                this.showModalSecurityGuardAdd=true
                this.$refs.mySecurityGuardAdd.init();
            },
            toggleModalMedicinerAdd(){
                this.closeMedicinerAdd();
                this.$refs.myMedicinerAdd.init();
            },
            toggleModalElderlyAdd(){
                this.closeElderlyAdd();
                this.$refs.myElderlyAdd.init();
            },
            toggleModalNurseAideAdd(){
                this.closeNurseAideAdd();
                this.$refs.myNurseAideAdd.init();
            },
            toggleModalDeanAdd(){
                this.closeDeanAdd();
                this.$refs.myDeanAdd.init();
            },
            toggleModalFinanceAdd(){
                this.closeFinanceAdd();
                this.$refs.myFinanceAdd.init();
            },
            closeNurseAdd(){
                this.showModalNurseAdd = !this.showModalNurseAdd;
            },
            closeNurseEdit(){
                this.showModalNurseEdit = !this.showModalNurseEdit;
            },
            closeMedicinerAdd(){
                this.showModalMedicinerAdd = !this.showModalMedicinerAdd;
            },
            closeMedicinerEdit(){
                this.showModalMedicinerEdit = !this.showModalMedicinerEdit;
            },
            closeElderlyAdd(){
                this.showModalElderlyAdd = !this.showModalElderlyAdd;
            },
            closeElderlyEdit(){
                this.showModalElderlyEdit = !this.showModalElderlyEdit;
            },
            closeNurseAideAdd(){
                this.showModalNurseAideAdd = !this.showModalNurseAideAdd;
            },
            closeNurseAideEdit(){
                this.showModalNurseAideEdit = !this.showModalNurseAideEdit;
            },
            closeDeanAdd(){
                this.showModalDeanAdd = !this.showModalDeanAdd;
            },
            closeDeanEdit(){
                this.showModalDeanEdit = !this.showModalDeanEdit;
            },
            closeFinanceAdd(){
                this.showModalFinanceAdd = !this.showModalFinanceAdd;
            },
            closeFinanceEdit(){
                this.showModalFinanceEdit = !this.showModalFinanceEdit;
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },

            getList(){
                this.loading = true;
                var departmentCode=this.departmentCode
                if(!departmentCode){
                    departmentCode='00000000-0000-0000-0000-000000000000'
                }
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"User/GetPageListByRenShi",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        phone:this.phone,
                        name:this.name,
                        status:this.status-1,
                        userType:this.userType,
                        departmentCode:departmentCode,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    this.loading = false;
                    this.disabledEdit = true;
                    this.disabledDaKa = true;
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            statusTitle(row){
                if(row.status == 0){
                    return "正常";
                }
                if(row.status == 1){
                    return "禁用";
                }
                return "其它";
            },
            getUserType(row,index,column){
                return this.allStatus(column,['默认','老人','子女','医生','护士','护工','员工','保安','院长','财务'])
            },
            allStatus(row,status){
                for(var i in status){
                    if(i==row){
                        return status[i]
                    }
                }
                return "其它";
            }


        }
    }
</script>
<style lang="scss" scoped>
    /deep/ .el-table__body tr.current-row>td {
        background-color: #409EFF;
        color:#fff;
    }
</style>
